<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span class="text" v-html="message"></span>
            <span class="text" v-html="name"></span>
          </div>
          <div class="action text-right">
            <a v-if="showCancel" @click="$emit('close')" class="btn btn-default" :disabled="buttonDisabled">{{cancelText}}</a>
            <a @click="$emit('send')" class="btn btn-primary" :disabled="buttonDisabled">{{confirmText}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'WarningModal2',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
      name () {
        this.registerHanlink()
      },
    },
  computed: {
    ...mapGetters(['BaseUrl'])
  },
}
</script>
